import CaseAnalysisError from './CaseAnalysisError'

export default CaseAnalysisError
